import { Expose } from 'class-transformer';
import { SnModel } from '@lib/common/models';

export class SkydioMarkerDetails extends SnModel {
  /** The incident type code. */
  @Expose({ name: 'code' })
  public code?: string;

  /** The identifier of the incident. Ex. case number, incident number, etc. */
  @Expose({ name: 'incident_id' })
  public incidentId?: string;

  /** The priority of the incident. Eg: P0, P1, P2 */
  @Expose({ name: 'priority' })
  public priority?: string;

  constructor(data: any = {}) {
    super();
    this.fromJSON(data);
  }
}
